import { useEffect, useState } from "react";

import { TransfiyaBanksService, type TransfiyaBank } from "../services/transfiyaBanks.service";

let cached: TransfiyaBank[] | null = null;
let inFlight: Promise<TransfiyaBank[]> | null = null;

function loadBanks(): Promise<TransfiyaBank[]> {
  if (cached) return Promise.resolve(cached);
  inFlight ??= TransfiyaBanksService.list()
    .then((res) => {
      cached = res.data;
      return res.data;
    })
    .finally(() => {
      inFlight = null;
    });
  return inFlight;
}

/** The participant-bank directory, read once per session; a failed read is never cached. */
export function useTransfiyaBanks(enabled: boolean) {
  const [banks, setBanks] = useState<TransfiyaBank[] | null>(cached);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!enabled || cached) return;
    let cancelled = false;
    loadBanks().then(
      (list) => {
        if (!cancelled) setBanks(list);
      },
      () => {
        if (!cancelled) setFailed(true);
      },
    );
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { banks: banks ?? cached, isLoading: enabled && !banks && !cached && !failed, failed };
}
